import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useAuth } from 'react-oidc-context';

import './admin-welcome-page.styl';
import { Button } from '@nazka/nazka.mapframe.components';

function AdminWelcomePage({
  isApproved,
}) {
  const { t } = useTranslation();

  const {
    isLoading,
    isAuthenticated,
    signoutRedirect,
    signinRedirect,
  } = useAuth();

  return (
    <div className="admin-welcome-page">
      <img
        src="/img/logo/climate-champions-text-logo.svg"
        alt="Climate Champions logo"
        className="admin-welcome-page__logo"
      />
      <h1>
        {t('Welcome to the Climate Champions CMS')}
      </h1>
      {isLoading && (
        <p>{t('Checking your login status...')}</p>
      )}
      {!isLoading && !isAuthenticated && (
        <div className="admin-welcome-page__not-signed-in">
          <p>
            {t('Already have an account?')}
            <Button
              layout="outlined"
              onClick={signinRedirect}
            >
              {t('Log in')}
            </Button>
          </p>
          <p>
            {t('New to the Climate Champions team?')}
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: '16px' }}
              href={`${import.meta.env.VITE_COGNITO_DOMAIN}/signup?client_id=${import.meta.env.VITE_COGNITO_CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=${window.location.origin}/admin`}
            >
              {t('Create account')}
            </a>
          </p>
        </div>
      )}
      {isAuthenticated && !isApproved && (
        <div className="admin-welcome-page__not-approved">
          <p>
            {t('Your account has not been approved yet.')}
          </p>
          <Button
            onClick={async () => {
              await signoutRedirect({
                extraQueryParams: {
                  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
                  logout_uri: `${window.location.origin}/admin`,
                },
              });
            }}
          >
            {t('Log out')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default AdminWelcomePage;